import {
  Table,
  TableColumn,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Input,
  Dialog,
  Button,
  Steps,
  Step,
  Popover,
  Upload,
  Pagination,
  DatePicker,
  Alert,
  Message,
  MessageBox,
  Tooltip,
  Loading,
  RadioButton,
  CheckboxGroup,
  InputNumber
} from '@jd/element-ui'

const components = [
  Table,
  TableColumn,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  Checkbox,
  RadioGroup,
  Radio,
  Input,
  Dialog,
  Button,
  Steps,
  Step,
  Upload,
  Pagination,
  DatePicker,
  Popover,
  Alert,
  Tooltip,
  RadioButton,
  CheckboxGroup,
  InputNumber
]

const install = Vue => {
  if (install.installed) {
    return
  }
  components.forEach(component => {
    Vue.component(component.name, component)
  })
  Vue.prototype.$jcmsgbox = MessageBox
  Vue.$jcalert = Vue.prototype.$jcalert = MessageBox.alert
  Vue.prototype.$jcconfirm = MessageBox.confirm
  Vue.prototype.$jcprompt = MessageBox.prompt
  Vue.prototype.$jcmessage = Message
  Vue.use(Loading.directive)
  Vue.$loading = Vue.prototype.$loading = Loading.service
}
export default {
  install
}
